import { Component, OnInit } from '@angular/core';
import { ApiService } from '../../services/api.service';
import { SharedService } from '../../services/shared.service';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-share-holding',
  templateUrl: './share-holding.component.html',
  styleUrls: ['./share-holding.component.scss']
})
export class ShareHoldingComponent implements OnInit {
  public companyId: string;
  public topCompanies: any;
  public tableFields = [
    { title: 'name', name: 'Company', type: 'string', isLink: false, unit: '' },
    { title: 'type', name: 'Type', type: 'string', isLink: false, unit: '' },
    { title: 'noofshares', name: 'No. of Shares', type: 'string', isLink: false, unit: '' },
    { title: 'perstake', name: '% Share Holding', type: 'string', isLink: false, unit: '' },
    { title: 'date', name: 'Date', type: 'date', isLink: false, unit: '' },
  ];

  constructor(private _api: ApiService,
    public _shared: SharedService,
    private _route: ActivatedRoute,
    private _router: Router) {
    this._router.routeReuseStrategy.shouldReuseRoute = () => false;
  }

  ngOnInit() {
    this.companyId = this._route.snapshot.paramMap.get('id');
    this.getTopShareholdingCompanies();
  }

  getTopShareholdingCompanies() {
    this._api.getTopShareholdingCompanies({ co_code: this.companyId }).subscribe((response) => {
      this.topCompanies = response;
    });
  }

}
